import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { Checkbox } from "../../../../../components/checkbox/Checkbox";
import { changeSafeSearchService } from "../../../../../store/profiles/profile.actions";

const SAFE_SEARCH_ORDER = ["google", "bing", "youtube"];

export const SafeSearch = ({ className, services, profileId }) => {
  const dispatch = useDispatch();

  return (
    <Fragment>
      <div className={"subsection-header"}>
        <h3>
          <FormattedMessage id={"search_protection"} />
        </h3>
      </div>
      <fieldset>
        <legend>
          <FormattedMessage id={"search_protection_description"} />
        </legend>
        {_.map(
          _.intersection(SAFE_SEARCH_ORDER, _.keys(services)),
          (option, key) => (
            <div className={className} key={key}>
              <Checkbox
                id={option}
                name={option}
                label={<FormattedMessage id={`${option}_request_fail`} />}
                checked={services[option]}
                onChange={({ currentTarget: { checked } }) =>
                  dispatch(changeSafeSearchService(profileId, option, checked))
                }
              />
            </div>
          )
        )}
      </fieldset>
    </Fragment>
  );
};
